import * as React from 'react';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { BowtieCase, CaseRegistrationTemplate } from '../../types';
import { TooltipCaseNumber } from './tooltip-case-number';
import { TooltipData } from './tooltip-data';

const caseNumber: string = 'CaseNumber';
const caseNo: string = 'CaseNo';
const caseType: string = 'CaseType';

export const renderFieldFactory = (applicationUrl: string) =>
  (caseData: BowtieCase, fieldName: string) => {

    const fields = {
      [caseNumber]: <TooltipCaseNumber
        value={caseData?.caseNumber?.toString()} />,
      [caseType]: <TooltipData
        data={isDefinedIncludingZero(caseData?.caseType?.v) ? [caseData.caseType] : []}
        renderIcon={false}
        applicationUrl={applicationUrl}
      />
    };

    const normalizedFieldName = Object.keys(caseData?.fields ?? {})
      .find(field => field.toLowerCase() === fieldName.toLowerCase());

    const data = caseData?.fields?.[normalizedFieldName];

    const defaultField = data?.values?.length
      ? <TooltipData
        data={data?.values}
        renderIcon={true}
        applicationUrl={applicationUrl}
      />
      : null;

    return fields[fieldName] || defaultField;
  };

export const renderLabelFactory = (caseTemplate: CaseRegistrationTemplate) =>
  (caseData: BowtieCase, fieldName: string) => {

    if (fieldName === caseNumber) {
      return caseTemplate.labels[caseNo].text;
    }

    return fieldName in (caseTemplate?.caseDataTemplate?.fields ?? {})
      ? caseTemplate.caseDataTemplate.fields[fieldName].text
      : fieldName in (caseTemplate?.labels ?? {})
        ? caseTemplate.labels[fieldName].text
        : '';
  };
